import useBoolean from '@eduzz/houston-hooks/useBoolean';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, useMediaQuery } from '@material-ui/core';
import type { Theme } from '@material-ui/core/styles';
import moment from 'moment';
import React, { useCallback } from 'react';
import BlackFridayChallenge from 'v2/components/Pages/Elite/BlackFridayChallenge';
import { useElite } from 'v2/hooks/useElite';

import { useStyles } from './styles';

interface IStorageBlackFriday {
  showAgain?: Date;
}

const LOCAL_STORAGE_KEY = 'modal_blackfriday_seen';

const BlackFriday = () => {
  const [open, toggle] = useBoolean(false);
  const classes = useStyles();
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('xs'));
  const eliteListQuery = useElite();
  const { data } = eliteListQuery;

  const isBlackFridayHappening = false;

  const handleJoinBlackFriday = useCallback(async () => {
    eliteListQuery.refetch();
  }, [eliteListQuery]);

  const saveBlackfridayModalShowToLocalStorage = (storagedBlackFriday: IStorageBlackFriday) => {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(storagedBlackFriday));
  };

  const handleClose = () => {
    const newDate = moment().startOf('day').add(1, 'd').toDate();
    const newStoraged = { showAgain: newDate };
    saveBlackfridayModalShowToLocalStorage(newStoraged);
    toggle();
  };

  React.useEffect(() => {
    if (data?.already_joined_blackfriday_challenge || data?.already_joined_blackfriday_challenge == undefined) {
      return;
    }

    const storagedBlackFriday: IStorageBlackFriday = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY)) || {};
    const storageDate = moment(storagedBlackFriday.showAgain).startOf('day');

    if (moment().isAfter(storageDate)) {
      toggle();
    }
  }, [data?.already_joined_blackfriday_challenge, toggle]);

  if (!isBlackFridayHappening) {
    return null;
  }

  return (
    <Dialog
      classes={{
        paper: classes.paper,
      }}
      open={open}
      onClose={handleClose}
      fullScreen={isMobile}
      scroll='paper'
    >
      <DialogTitle>O caminho para o Sucesso: Badges exclusivas da Black Friday Eduzz 2023!</DialogTitle>
      <DialogContent className={classes.content} dividers>
        <img className={classes.image} src='/img/banner-blackfriday-2023.png' />
        <DialogContentText className={classes.contentText} tabIndex={-1}>
          <p>Prepare-se para conquistar novos níveis na Eduzz</p>
          <p>
            Mostre toda sua performance e se desafie ainda mais com as novas Badges da Black Friday. Com essas conquistas você recebe o reconhecimento
            exclusivo que merece e abre as portas para novas oportunidades. Não perca essa vantagem e dê mais um passo na sua evolução.
          </p>
          <p>Clique em 'Quero Participar' e multiplique seu negócio!</p>
        </DialogContentText>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button variant='text' onClick={handleClose}>
          Ver depois
        </Button>
        <div>
          <BlackFridayChallenge
            alreadyJoinedBlackFridayChallenge={data?.already_joined_blackfriday_challenge}
            handleJoinBlackFriday={handleJoinBlackFriday}
          />
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default BlackFriday;
